import NotificationImportantOutlinedIcon from '@mui/icons-material/NotificationImportantOutlined';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { timeFormatter } from '@act/shared/utilities';

interface DueDateAlertIconProps {
  dueDate: number;
  isCompleted: boolean;
}

export const DueDateAlertIcon = ({
  dueDate,
  isCompleted,
}: DueDateAlertIconProps) => {
  const differenceFromToday = timeFormatter.differenceInDaysFromNow(dueDate);
  let dueDateAlertIcon = null;

  if (!isCompleted) {
    if (differenceFromToday <= 7 && differenceFromToday >= 0) {
      dueDateAlertIcon = <WarningAmberRoundedIcon color="warning" />;
    }

    if (differenceFromToday < 0) {
      dueDateAlertIcon = <NotificationImportantOutlinedIcon color="error" />;
    }
  }

  return dueDateAlertIcon;
};
